module.exports = __webpack_public_path__ + "img/enterprise-main05.e7ba9781.jpg";